import useMapOrdersSettingsQuery from "../queries/mapOrders/useMapOrdersSettings";
import useDeliveryOrders from "./useDeliveryOrders";

const useCourierOrders = () => {
  const { data } = useMapOrdersSettingsQuery();
  return useDeliveryOrders(
    data?.statuses ?? [1, 2, 3, 4],
    data?.merge_formulas
  );
};

export default useCourierOrders;
